import { render, staticRenderFns } from "./BusinessUnits.vue?vue&type=template&id=22417c26&scoped=true&"
import script from "./BusinessUnits.vue?vue&type=script&lang=js&"
export * from "./BusinessUnits.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnits.vue?vue&type=style&index=0&id=22417c26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22417c26",
  null
  
)

export default component.exports